import { Component, Input, OnInit } from '@angular/core';
import { FlashController } from 'src/app/flash-payment/flash-payment-core/services/flash-controller.service';

@Component({
  selector: 'app-wallet',
  templateUrl: './wallet.component.html',
  styleUrls: ['../way-to-pay.component.sass']
})
export class WalletComponent implements OnInit {
  @Input() cantShowArrows: boolean;
  constructor(public flashPaymentService: FlashController) { }

  ngOnInit(): void {
  }

}
